import { GET, POST } from "./api.js";

export const nk = {
  nkConsult: (data) => GET(`/n-k`, data),
  nkGenerator: (data) => POST(`/n-k/generator`, data),
}

